module.exports = __webpack_public_path__ + "images/emoji/tennis.b886c28de6afc85494a0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tennis.png
// module id = xwfm
// module chunks = 14